<template>
    <div>
        <Panel
            :title="$t('Email Notifications')"
            :add-button="canEdit ? $t('Add Email Notification') : ''"
            :delete-button="selected.length > 0"
            :page="page"
            :total-rows="totalRows"
            @change="changePage"
            @delete="handleDelete"
            @input="openForm(-1)"
        >
            <table id="emailnotifications_table" class="cic-table">
                <thead>
                    <tr>
                        <th>{{ $t('Name') }}</th>
                        <th>{{ $t('Share To Child Organisations') }}</th>
                        <th>{{ $t('From Address') }}</th>
                        <th>{{ $t('To Addresses') }}</th>
                        <th v-if="canEdit"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="notification in items" @click="(evt) => handleOpen(notification.notificationId, evt)">
                        <td class="primary">
                            {{ notification.name }}
                        </td>
                        <td><cic-checkbox :enabled="false" :value="notification.share" /></td>
                        <td>{{ notification.fromAddress }}</td>
                        <td>{{ notification.toAddresses.join('; ') }}</td>
                        <td v-if="canEdit" class="td-checkbox">
                            <cic-checkbox
                                v-if="canEditDetails(notification.orgId)"
                                :value="selected.includes(notification.notificationId)"
                                @click="handleSelected(notification.notificationId)"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </Panel>

        <edit-transmit-notification
            v-if="item !== null && !$store.showLoadingOverlay"
            :item="item"
            :templates="templates"
            @blur="closePopup"
            @input="saveItem"
            @updateFieldValue="updateFieldValue"
        />

        <div v-if="$store.showLoadingOverlay" class="cic-overlay"></div>
    </div>
</template>

<script>
    import Panel from '@/components/container/Panel';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import TableUtils from '@/mixins/TableUtils';
    import { deleteItems, load, save } from '@/utils/Http';
    import EditTransmitNotification from './EditTransmitNotification';

    export default {
        name: 'TransmitNotifications',
        components: {
            CicCheckbox,
            EditTransmitNotification,
            Panel,
        },
        mixins: [TableUtils],
        data() {
            return {
                item: null,
                items: [],
                page: 1,
                selected: [],
                templates: [],
                totalRows: 0,
            };
        },
        computed: {
            canEdit() {
                return this.$store.hasRight('EDIT_TRANSMIT_NOTIFICATIONS');
            },
        },
        created() {
            this.loadTable();
        },
        methods: {
            canEditDetails(orgId) {
                return orgId === this.$store.user.orgId;
            },

            handleDelete() {
                deleteItems('transmit/notifications/delete', { notificationIds: this.selected }, () => {
                    this.selected = [];
                    this.loadTable();
                });
            },

            loadTable() {
                this.closePopup();
                load('transmit/notifications/get', { page: this.page }, (response) => {
                    this.items = response.notifications;
                    this.templates = response.templates;
                    this.totalRows = response.totalRows;
                });
            },

            openForm(notificationId) {
                if (notificationId > 0) {
                    this.item = this.items.find((x) => x.notificationId === notificationId);
                } else {
                    this.item = {
                        notificationId: null,
                        orgId: this.$store.user.orgId,
                        share: false,
                        name: '',
                        fromAddress: '',
                        toAddresses: [],
                        ccAddresses: [],
                        bccAddresses: [],
                        parameters: {
                            SuccessTemplateID: null,
                            FailureTemplateID: null,
                        },
                    };
                }
            },

            saveItem() {
                save('transmit/notification/update', { data: JSON.stringify(this.item) }, () => {
                    this.selected = [];
                    this.loadTable();
                });
            },

            updateFieldValue(field, value) {
                if (field === 'SuccessTemplateID' || field === 'FailureTemplateID') {
                    this.item.parameters[field] = value;
                } else {
                    this.item[field] = value;
                }
            },
        },
    };
</script>
